<template>
    <v-container
        fluid
    >
        <v-row
            align="center"
        >
            <v-col
                cols="12"
                lg="6"
                offset-lg="3"
                class="text-h3 text-center blue-grey--text text--darken-3"
            >
                <v-img :src="digital_tugue_logo" max-height="200" contain></v-img>
            </v-col>

            <!-- <v-col
                cols="12"
                lg="6"
                offset-lg="3"
                class="text-h3 text-center blue-grey--text text--darken-3"
            >
                Digital Tuguegarao
            </v-col> -->

            <v-col
                cols="12"
                lg="6"
                offset-lg="3"
                class="text-left"
            >
                <v-text-field
                    v-model="username"
                    label="Enter your Username"
                    :outlined="true"
                    :hint="'CRM Username'"
                    @keyup.enter="LoginProcess"
                    :prepend-inner-icon="'mdi-account'"
                ></v-text-field>
            </v-col>

            <v-col
                cols="12"
                lg="6"
                offset-lg="3"
                class="text-left"
            >
                <v-text-field
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    :prepend-inner-icon="'mdi-shield-key-outline'"
                    :type="showPass ? 'text' : 'password'"
                    v-model="password"
                    label="Enter your Password"
                    @click:append="showPass = !showPass"
                    @keyup.enter="LoginProcess"
                    :outlined="true"
                    :hint="'Your Password'"
                ></v-text-field>
            </v-col>

            <v-col
                cols="12"
                lg="6"
                offset-lg="3"
                class="text-left"
            >
                <v-btn
                    rounded
                    color="teal darken-4"
                    dark
                    block
                    elevation="6"
                    large
                    @click="LoginProcess"
                ><v-icon>mdi-login-variant</v-icon>&nbsp;&nbsp;Login</v-btn>
            </v-col>

            <v-col
                cols="12"
                lg="6"
                offset-lg="3"
                class="text-right"
            >
                <v-btn
                    text
                    color="green darken-4"
                    @click="AddNewRecord"
                >Sign Up</v-btn>

                <v-btn
                    text
                    color="red darken-4"
                    @click="ForgotPasswordTrigger()"
                >Forgot Password</v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="resetpassworddialog" persistent max-width="680">
            <v-card>
                <v-card-title class="headline">TugueGov Reset Password</v-card-title>
                <v-card-text>
                    <v-row class="mt-6 mb-6" dense>
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                outlined
                                v-model="resetpassword.new"
                                label="* New Password"
                                type="password"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                outlined
                                v-model="resetpassword.confirm"
                                label="* Confirm New Password"
                                type="password"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="resetpassworddialog = false">Close</v-btn>
                    <v-btn color="green darken-1" text @click="ResetPassword" :disabled="resetpassword.new.toString().length == 0 || resetpassword.confirm.toString().length == 0">Reset Password</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="forgotpassworddialog" persistent max-width="680">
            <v-card>
                <v-card-title class="headline">TugueGov Forgot Password</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <v-card
                                class="mx-auto"
                                outlined
                                color="#385F73"
                                dark
                            >
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <v-list-item-title>To reset your password</v-list-item-title>
                                        <v-list-item-subtitle>Provide your username in the field below, then click "<b>Text me an OTP code</b>"<br />We will send a 6-digit OTP (One-Time-Password) to your mobile number and E-mail address</v-list-item-subtitle>
                                        <v-list-item-subtitle>Enter the OTP Code that has been texted to you in the field below for verification</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                label="Enter your Username"
                                filled
                                v-model="forgotpass.username"
                                hint="Your Account Username"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-btn color="blue darken-1" :disabled="forgotpass.username.toString().length == 0" text @click="SendOTP(isforgotpass)">Text me an OTP code</v-btn>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="forgototpcode"
                                label="Enter the 6-digit OTP Code here"
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="forgotpassworddialog = false">Close</v-btn>
                    <v-btn color="green darken-1" text @click="ForgotPasswordProcess" :disabled="forgototpcode.toString().length != 6">Verify OTP Code</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar
            v-model="showSnackbar"
            :color="snackbarVariant"
            :timeout="3000"
            :top="'top'"
            centered
            elevation="24"
            style="z-index: 9999"
            class="mt-6"
        >
            <v-layout color="transparent" dark>{{ modalMessage }}</v-layout>
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="showSnackbar = false"
                >
                    <i class="mdi mdi-close"></i>
                </v-btn>
            </template>
        </v-snackbar>

        <v-dialog v-model="activationdialog" persistent max-width="680">
            <v-card>
                <v-card-title class="headline">TugueGov User Activation</v-card-title>
                <v-card-text>
                    <v-row class="mt-6 mb-6" dense>
                        <!-- <v-col
                            cols="12"
                        >
                            <vue-tel-input
                                v-model="mobile"
                                defaultCountry="PH"
                                placeholder="Enter your Mobile #"
                                autocomplete="off"
                                @validate="ValidatePhoneNumber"
                            ></vue-tel-input>
                        </v-col> -->

                        <v-col
                            cols="12"
                        >
                            <v-card
                                class="mx-auto"
                                outlined
                                color="#385F73"
                                dark
                            >
                                <v-list-item three-line>
                                    <v-list-item-content>
                                        <v-list-item-title>To activate your account</v-list-item-title>
                                        <v-list-item-subtitle>We will send a 6-digit OTP (One-Time-Password) to your mobile number and E-mail address</v-list-item-subtitle>
                                        <v-list-item-subtitle>Enter the OTP Code that has been texted to you in the field below for verification</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="otpcode"
                                label="Enter the 6-digit OTP Code here"
                                outlined
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-btn
                                small
                                text
                                @click="SendOTP(isforgotpass)"
                            >
                                Send another OTP Code
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="activationdialog = false">Close</v-btn>
                    <v-btn color="green darken-1" text @click="ActivateAccountV2" :disabled="otpcode.length != 6">Activate</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="cropform"
            scrollable
            max-width="1000"
            overlay-opacity="0.7"
            persistent
        >
            <v-card>
                <v-card-title class="headline grey lighten-5 black--text"><i class="mdi mdi-crop mr-2"></i>Crop Photo</v-card-title>
                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-col
                        cols="12"
                    >
                        <cropper
                            v-if="citizen.cphoto"
                            class="cropper"
                            :src="citizen.cphotodata"
                            :stencil-props="{
                            aspectRatio: 2/2
                            }"
                            @change="CropPhoto"
                        ></cropper>
                    </v-col>
                </v-card-text>

                <v-card-actions
                    class="grey lighten-5"
                >
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-3" text @click="SelectCroppedPhoto">
                        <v-icon class="mr-2">mdi-crop</v-icon>Crop Photo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="citizenform"
            scrollable
            max-width="1000"
            overlay-opacity="0.7"
            persistent
        >
            <v-card>
                <v-card-title class="headline grey lighten-5 black--text"><i class="mdi mdi-account-box-outline mr-2"></i>Citizen Details</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-tabs
                        grow
                        class="mt-5"
                        v-model="active_tab"
                        color="teal darken-3"
                        @change="MapInvalidateSize"
                    >
                        <v-tab v-for="(tab, i) of tabs" :key="tab.id">
                            <v-icon left v-if="i == 0 && citizen.accounttype.toString() == 'corporation'" class="mr-2">mdi-office-building</v-icon>
                            <v-icon left v-else class="mr-2">{{tab.name}}</v-icon>{{tab.text}}
                        </v-tab>

                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col
                                            cols="12"
                                            v-if="citizen.citizen_id.toString().length == 0"
                                        >
                                            <v-select
                                                v-model="citizen.accounttype"
                                                label="* Account Type"
                                                :items="accounttypes"
                                                item-text="text"
                                                item-value="value"
                                                dense
                                            ></v-select>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            lg="6"
                                            md="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="* First Name"
                                                type="text"
                                                v-model="citizen.firstname"
                                                ref="citfirstname"
                                                dense
                                                @keyup="FullnameFormat"
                                                @blur="citizen.firstname = StartCase(citizen.firstname)"
                                            ></v-text-field>
                                        </v-col>
                                        
                                        <v-col
                                            cols="12"
                                            lg="6"
                                            md="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="* Middle Name"
                                                type="text"
                                                v-model="citizen.middlename"
                                                dense
                                                @keyup="FullnameFormat"
                                                @blur="citizen.middlename = StartCase(citizen.middlename)"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            lg="6"
                                            md="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="* Last Name"
                                                type="text"
                                                v-model="citizen.lastname"
                                                dense
                                                @keyup="FullnameFormat"
                                                @blur="citizen.lastname = StartCase(citizen.lastname)"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            lg="6"
                                            md="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="Extension Name (e.g. Jr., Sr., III)"
                                                type="text"
                                                v-model="citizen.extensionname"
                                                dense
                                                @keyup="FullnameFormat"
                                                @blur="citizen.extensionname = StartCase(citizen.extensionname)"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            lg="6"
                                            class="d-none"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="Full Name Format 1"
                                                type="text"
                                                v-model="citizen.fullname_format1"
                                                disabled
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            lg="6"
                                            class="d-none"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="Full Name Format 2"
                                                type="text"
                                                v-model="citizen.fullname_format2"
                                                disabled
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <vue-tel-input
                                                v-model="citizen.mobile"
                                                defaultCountry="PH"
                                                placeholder="* Enter your Mobile #"
                                                autocomplete="off"
                                                @validate="PhoneNumberUpdate"
                                            ></vue-tel-input>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-select
                                                :items="genders"
                                                label="* Gender"
                                                item-text="text"
                                                item-value="value"
                                                v-model="citizen.gender"
                                                dense
                                            ></v-select>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-dialog
                                                ref="dialog"
                                                v-model="birthdatemodal"
                                                :return-value.sync="citizen.birthdate"
                                                persistent
                                                width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="citizen.birthdate"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        label="* Birthdate"
                                                        dense
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="citizen.birthdate"
                                                    scrollable
                                                    :max="maxDate"
                                                    color="green darken-3"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="red darker-3" @click="birthdatemodal = false">Cancel</v-btn>
                                                    <v-btn text color="green darker-3" @click="$refs.dialog.save(citizen.birthdate)">OK</v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="* Birth Place"
                                                type="text"
                                                v-model="citizen.birthplace"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="* Email Address"
                                                type="text"
                                                v-model="citizen.email"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                            class="d-none"
                                        >
                                            <v-text-field
                                                label="Fathers Name"
                                                type="text"
                                                v-model="citizen.fathers_name"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                            class="d-none"
                                        >
                                            <v-text-field
                                                label="Mothers Maiden Name"
                                                type="text"
                                                v-model="citizen.mothers_maiden_name"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                            class="d-none"
                                        >
                                            <v-text-field
                                                label="Nationality"
                                                type="text"
                                                v-model="citizen.nationality"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                            class="d-none"
                                        >
                                            <v-select
                                                :items="civil_statuses"
                                                label="Civil Status"
                                                item-text="text"
                                                item-value="value"
                                                v-model="citizen.civil_status"
                                                dense
                                            ></v-select>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'individual' && citizen.civil_status.toString().toUpperCase() == 'M'"
                                        >
                                            <v-text-field
                                                label="* Spouse Name"
                                                type="text"
                                                v-model="citizen.spousename"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-text-field
                                                label="* Company Name"
                                                type="text"
                                                v-model="citizen.companyname"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-text-field
                                                label="* Type of Business"
                                                type="text"
                                                v-model="citizen.businesstype"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <vue-tel-input
                                                v-model="citizen.mobile"
                                                defaultCountry="PH"
                                                placeholder="* Contact Number/Telephone Number"
                                                autocomplete="off"
                                                @validate="PhoneNumberUpdate"
                                            ></vue-tel-input>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-text-field
                                                label="* Email Address"
                                                type="text"
                                                v-model="citizen.email"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-dialog
                                                ref="dialog"
                                                v-model="dateestablishedmodal"
                                                :return-value.sync="citizen.date_established"
                                                persistent
                                                width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="citizen.date_established"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        label="Date Established"
                                                        dense
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="citizen.date_established"
                                                    scrollable
                                                    :max="maxDate"
                                                    color="green darken-3"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="red darker-3" @click="dateestablishedmodal = false">Cancel</v-btn>
                                                    <v-btn text color="green darker-3" @click="$refs.dialog.save(citizen.date_established)">OK</v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-text-field
                                                label="TIN #"
                                                type="text"
                                                v-model="citizen.tin"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-alert type="info">Company Representative</v-alert>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-text-field
                                                label="* Name"
                                                type="text"
                                                v-model="citizen.representative.name"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <vue-tel-input
                                                v-model="citizen.representative.contactnumber"
                                                defaultCountry="PH"
                                                placeholder="* Contact Number/Telephone Number"
                                                autocomplete="off"
                                                @validate="PhoneNumberUpdateRep"
                                            ></vue-tel-input>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="6"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-text-field
                                                label="* Email Address"
                                                type="text"
                                                v-model="citizen.representative.email"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-file-input
                                                label="* Upload your Photo"
                                                outlined
                                                dense
                                                show-size accept="image/jpeg, image/png"
                                                @change="FileAttachment"
                                                v-model="citizen.cphoto"
                                                prepend-inner-icon="mdi-file-find-outline"
                                                chips
                                                small-chips
                                                counter
                                                class="mt-3"
                                            ></v-file-input>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-file-input
                                                label="* Upload a Valid I.D."
                                                outlined
                                                dense
                                                show-size accept="image/jpeg, image/png"
                                                @change="FileAttachmentValidId"
                                                v-model="citizen.cphotovalidid"
                                                prepend-inner-icon="mdi-file-find-outline"
                                                chips
                                                small-chips
                                                counter
                                                class="mt-3"
                                            ></v-file-input>
                                        </v-col>
                                    </v-row>

                                    <v-row dense>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-checkbox
                                                v-model="citizen.tugueresident"
                                                label="Are you a Tuguegarao Resident? uncheck if not."
                                            ></v-checkbox>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            class="text-h5 p-2 d-none"
                                        >
                                            <v-row>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="4"
                                                    lg="4"
                                                >
                                                    <v-switch
                                                        v-model="citizen.address.permanent.istugue"
                                                        label="Tuguegarao Address"
                                                        @change="PermanentAddressChange"
                                                        inset
                                                    ></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            class="subtitle-1"
                                        >
                                            Tuguegarao Address
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.permanent.istugue ? 6 : 4"
                                            :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="*Address 1"
                                                type="text"
                                                v-model="citizen.address.permanent.address1"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.permanent.istugue ? 6 : 4"
                                            :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="Address 2"
                                                type="text"
                                                v-model="citizen.address.permanent.address2"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.permanent.istugue ? 6 : 4"
                                            :class="citizen.address.permanent.istugue ? '' : 'd-none'"
                                        >
                                            <v-text-field
                                                label="* Street Address"
                                                type="text"
                                                v-model="citizen.address.permanent.street"
                                                dense
                                                hint="e.g. Enrile Boulevard, Regional Government Center"
                                                persistent-hint
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.permanent.istugue ? 6 : 4"
                                            :class="citizen.address.permanent.istugue ? '' : 'd-none'"
                                        >
                                            <v-select
                                                :items="brgy"
                                                label="* Barangay"
                                                item-text="BarangayName"
                                                item-value="BarangayCode"
                                                v-model="citizen.address.permanent.brgy"
                                                dense
                                                @change="ReverseGeocoderPermanent"
                                            ></v-select>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* City"
                                                type="text"
                                                v-model="citizen.address.permanent.city"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* Province"
                                                type="text"
                                                v-model="citizen.address.permanent.province"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* Country"
                                                type="text"
                                                v-model="citizen.address.permanent.country"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="ZIP Code"
                                                type="text"
                                                v-model="citizen.address.permanent.zipcode"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            class="d-none"
                                        >
                                            <div style="height: 300px; width: 100%;">
                                                <l-map
                                                    style="height: 300px;"
                                                    ref="myMap"
                                                    @ready="onreadymap()"
                                                    :center="center"
                                                    :options="mapOptions"
                                                    :zoom="citizen.address.permanent.zoom"
                                                >
                                                    <l-tile-layer
                                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        :attribution="attribution"
                                                        @update:lat-lng="UpdateLocationPermanent"
                                                    />
                                                    <l-marker :lat-lng="citizen.address.permanent.latlng" draggable></l-marker>
                                                </l-map>
                                            </div>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-btn
                                                text
                                                color="orange darken-3"
                                                @click="CopyPermanentAddress"
                                            ><v-icon>mdi-content-copy</v-icon></v-btn>&nbsp;Same as Tuguegarao Address
                                        </v-col>

                                        <!-- Present Address -->

                                        <v-col
                                            cols="12"
                                            class="subtitle-1"
                                        >
                                            Present Address
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            class="text-h5 d-none"
                                        >
                                            <v-row>
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    md="4"
                                                    lg="4"
                                                >
                                                    <v-switch
                                                        v-model="citizen.address.present.istugue"
                                                        label="Present Address"
                                                        @change="PresentAddressChange"
                                                        inset
                                                    ></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.present.istugue ? 6 : 4"
                                            :class="citizen.address.present.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* Address 1"
                                                type="text"
                                                v-model="citizen.address.present.address1"
                                                dense
                                                hint="e.g. Enrile Boulevard, Regional Government Center"
                                                persistent-hint
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.present.istugue ? 6 : 4"
                                            :class="citizen.address.present.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="Barangay"
                                                type="text"
                                                v-model="citizen.address.present.address2"
                                                dense
                                                hint="ignore if outside the Philippines"
                                                persistent-hint
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.present.istugue ? 6 : 4"
                                            :class="citizen.address.present.istugue ? '' : 'd-none'"
                                        >
                                            <v-text-field
                                                label="* Number/Street"
                                                type="text"
                                                v-model="citizen.address.present.street"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            :lg="citizen.address.present.istugue ? 6 : 4"
                                            :class="citizen.address.present.istugue ? '' : 'd-none'"
                                        >
                                            <v-select
                                                :items="brgy"
                                                label="* Barangay"
                                                item-text="BarangayName"
                                                item-value="BarangayCode"
                                                v-model="citizen.address.present.brgy"
                                                dense
                                                @change="ReverseGeocoderPresent"
                                            ></v-select>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.present.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* City"
                                                type="text"
                                                v-model="citizen.address.present.city"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.present.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* Province"
                                                type="text"
                                                v-model="citizen.address.present.province"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.present.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="* Country"
                                                type="text"
                                                v-model="citizen.address.present.country"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="6"
                                            lg="4"
                                            :class="citizen.address.present.istugue ? 'd-none' : ''"
                                        >
                                            <v-text-field
                                                label="ZIP Code"
                                                type="text"
                                                v-model="citizen.address.present.zipcode"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <!-- <v-col
                                            cols="12"
                                            :class="citizen.address.present.istugue ? '' : 'd-none'"
                                        > -->
                                        <v-col
                                            cols="12"
                                            class="d-none"
                                        >
                                            <div style="height: 300px; width: 100%;">
                                                <l-map
                                                    style="height: 300px;"
                                                    ref="myMap2"
                                                    @ready="onreadymap()"
                                                    :center="center2"
                                                    :options="mapOptions"
                                                    :zoom="citizen.address.present.zoom"
                                                >
                                                    <l-tile-layer
                                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        :attribution="attribution"
                                                    />
                                                    <l-marker :lat-lng="citizen.address.present.latlng" draggable></l-marker>
                                                </l-map>
                                            </div>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-btn
                                                text
                                                dark
                                                color="blue darken-2"
                                                @click="ReadTC"
                                            >
                                                Read the Terms and Conditions
                                            </v-btn>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-btn
                                                text
                                                dark
                                                color="blue darken-2"
                                                @click="privacydialog = true"
                                            >
                                                Read the Tuguegarao City Data Privacy Policy
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item class="d-none">
                            <v-card flat>
                                <v-card-text>
                                    
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item class="d-none">
                            <v-card flat>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col
                                            cols="12"
                                            md="4"
                                            lg="4"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="TIN #"
                                                type="text"
                                                v-model="citizen.tin"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            lg="4"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="Occupation"
                                                type="text"
                                                v-model="citizen.occupation"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            md="4"
                                            lg="4"
                                            v-if="citizen.accounttype.toString() == 'individual'"
                                        >
                                            <v-text-field
                                                label="Educational Attainment"
                                                type="text"
                                                v-model="citizen.educational_attainment"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-file-input
                                                label="SEC/DTI"
                                                outlined
                                                dense
                                                show-size accept="image/jpeg, image/png, application/pdf"
                                                @change="FileAttachmentSEC"
                                                v-model="citizen.secdti"
                                                prepend-inner-icon="mdi-file-find-outline"
                                                multiple
                                                chips
                                                small-chips
                                                counter
                                                class="mt-3"
                                            ></v-file-input>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            v-if="citizen.accounttype.toString() == 'corporation'"
                                        >
                                            <v-file-input
                                                label="Board Resolution Authorizing Company Representative"
                                                outlined
                                                dense
                                                show-size accept="image/jpeg, image/png, application/pdf"
                                                @change="FileAttachmentAuthRep"
                                                v-model="citizen.boardresolutionauthorizingrep"
                                                prepend-inner-icon="mdi-file-find-outline"
                                                multiple
                                                chips
                                                small-chips
                                                counter
                                                class="mt-3"
                                            ></v-file-input>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-alert type="info">In case of Emergency (Contact Person)</v-alert>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-text-field
                                                label="Name"
                                                v-model="citizen.incaseofemergency.name"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-text-field
                                                label="Address"
                                                v-model="citizen.incaseofemergency.address"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="12"
                                        >
                                            <v-text-field
                                                label="Contact Number"
                                                v-model="citizen.incaseofemergency.contactnumber"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item class="d-none">
                            <v-card flat>
                                <v-card-text>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            :class="img == defaultwebcam ? '' : 'd-none'"
                                        >
                                            <vue-web-cam
                                                ref="webcam"
                                                :device-id="deviceId"
                                                width="100%"
                                                @started="onStarted"
                                                @stopped="onStopped"
                                                @error="onError"
                                                @cameras="onCameras"
                                                @camera-change="onCameraChange"
                                            />
                                        </v-col>

                                        <v-col
                                            cols="12"
                                            :class="img != defaultwebcam ? 'text-center' : 'd-none'"
                                        >
                                            <figure>
                                                <v-img
                                                    :src="img"
                                                    contain
                                                ></v-img>
                                            </figure>
                                        </v-col>

                                        <v-col
                                            cols="4"
                                        >
                                            <v-btn color="primary" text @click="onCapture" :class="img == defaultwebcam ? '' : 'd-none'">
                                                <v-icon>mdi-camera-iris</v-icon>&nbsp;Capture Image
                                            </v-btn>
                                            <v-btn color="danger" text @click="onRenewCapture" :class="img != defaultwebcam ? '' : 'd-none'">
                                                <v-icon>mdi-camera</v-icon>&nbsp;Open Camera
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
                
                <v-card-actions
                    class="grey lighten-5"
                >
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-3" text @click="CloseDialog">
                        <v-icon class="mr-2">mdi-close</v-icon>Close
                    </v-btn>
                    <v-btn color="green darken-3" text @click="SaveProcess" :disabled="SaveProcessDisabled()">
                        <v-icon class="mr-2">mdi-send</v-icon>Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="privacydialog"
            scrollable
            max-width="680"
            overlay-opacity="0.7"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{ privacytitle }}
                </v-card-title>

                <v-card-text
                    v-html="privacyhtml"
                    class="pt-6 text-justify"
                ></v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="red darken-2"
                        text
                        @click="privacydialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="tcdialog"
            scrollable
            max-width="680"
            overlay-opacity="0.7"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{ tctitle }}
                </v-card-title>

                <v-card-text
                    v-html="tchtml"
                    class="pt-6 text-justify"
                    @scroll="TCScroll"
                    id="tccontainer"
                ></v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        text
                        @click="IAgree"
                        class="blue--text"
                    >
                        I accept
                    </v-btn>

                    <v-btn
                        color="red darken-2"
                        text
                        @click="tcdialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from "moment"
import _ from "lodash"
import axios from "axios"
import { Icon } from 'leaflet'
import { LMap, LTileLayer, LMarker } from "vue2-leaflet"
import 'leaflet/dist/leaflet.css'
import { Nominatim } from 'nominatim-geocoder'
import { WebCam } from "vue-web-cam"
import { Cropper } from 'vue-advanced-cropper'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
    name: 'app',
    metaInfo: {
        title: 'Digital Tuguegarao - Login',
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        'vue-web-cam': WebCam,
        Cropper,
    },
    data() {
        return {
            privacytitle: '',
            privacyhtml: '',
            privacydialog: false,
            tcbottom: false,
            tcdialog: false,
            tcagree: false,
            tctitle: '',
            tchtml: '',
            isforgotpass: true,
            resetpassworddialog: false,
            resetpassword: {
                new: '',
                confirm: '',
            },
            otpid: '',
            otpcode: '',
            forgototpcode: '',
            recordidtoactivate: '',
            croppedphoto: {
                coordinates: undefined,
                dataurl: undefined,
            },
            cropform: false,
            dateestablishedmodal: false,
            CRM_Interval: null,
            username: '',
            password: '',
            showPass: false,
            overlay: false,
            showSnackbar: false,
            snackbarVariant: 'red darken-3',
            modalMessage: '',
            activationdialog: false,
            mobile: '',
            mobileformatted: '',
            digital_tugue_logo: `${process.env.BASE_URL}images/DIGITALTUGUEGARAO.png`,
            tc_left_logo: `${process.env.BASE_URL}images/jpslogo.png`,
            tc_logo: `${process.env.BASE_URL}images/tc.png`,
            // tc_logo: `/Tuguegarao-CRM-User/images/tc.png`,
            forgotpassworddialog: false,
            forgotpass: {
                father: '',
                mother: '',
                username: ''
            },
            validnumber: false,
            // registration
            accounttypes: [
                {
                    value: 'individual',
                    text: 'Individual',
                },
                {
                    value: 'corporation',
                    text: 'Corporation',
                },
            ],
            maxDate: moment().toISOString().substr(0, 10),
            birthdatemodal: false,
            genders: [
                {
                    text: 'Male',
                    value: 'm'
                },
                {
                    text: 'Female',
                    value: 'f'
                }
            ],
            civil_statuses: [
                {
                    text: 'Single',
                    value: 'S'
                },
                {
                    text: 'Married',
                    value: 'M'
                }
            ],
            citizenform: false,
            citizen: {
                citizen_id: '',
                username: '',
                password: '',
                firstname: '',
                lastname: '',
                middlename: '',
                fullname_format1: '',
                fullname_format2: '',
                gender: 'm',
                birthdate: 0,
                mobile: '',
                mobilevalid: false,
                mobileformatted: '',
                email: '',
                address: {
                    permanent: {
                        street: '',
                        brgy: '',
                        city: 'Tuguegarao City',
                        province: 'Cagayan',
                        address1: '',
                        address2: '',
                        country: 'Philippines',
                        zipcode: 3500,
                        istugue: true,
                        latlng: [ 17.611138, 121.7257458 ],
                        zoom: 13
                    },
                    present: {
                        street: '',
                        brgy: '',
                        city: 'Tuguegarao City',
                        province: 'Cagayan',
                        address1: '',
                        address2: '',
                        country: 'Philippines',
                        zipcode: 3500,
                        istugue: false,
                        latlng: [ 17.611138, 121.7257458 ],
                        zoom: 13
                    }
                },
                fathers_name: '',
                mothers_maiden_name: '',
                civil_status: 'S',
                nationality: 'Filipino',
                tin: '',
                accounttype: 'individual',
                // new
                birthplace: '',
                spousename: '',
                occupation: '',
                educational_attainment: '',
                extensionname: '',
                incaseofemergency: {
                    name: '',
                    address: '',
                    contactnumber: '',
                },
                companyname: '',
                businesstype: '',
                date_established: '',
                representative: {
                    name: '',
                    email: '',
                    contactnumber: '',
                    mobilevalid: false,
                    mobileformatted: '',
                },
                secdti: [],
                secdtidata: [],
                boardresolutionauthorizingrep: [],
                boardresolutionauthorizingrepdata: [],
                tugueresident: true,
                cphoto: undefined,
                cphotodata: '',
                cphotovalidid: undefined,
                cphotovalididdata: '',
            },
            brgy: [],
            tabs: [
                { id: 1, name: 'mdi-account', text: 'Citizen Info' },
                // { id: 2, name: 'mdi-home-map-marker', text: 'Address' },
                // { id: 3, name: 'mdi-information-outline', text: 'Other Info' },
                // { id: 4, name: 'mdi-camera' }
            ],
            active_tab: 1,
            map: null,
            map2: null,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 13,
            center: [ 17.611138, 121.7257458 ],
            center2: [ 17.611138, 121.7257458 ],
            mapOptions: {
                zoomSnap: 0.5
            },
            img: `${process.env.BASE_URL}images/defaultwebcam.png`,
            imgvalidid: `${process.env.BASE_URL}images/defaultwebcam.png`,
            // img: `/Tuguegarao-CRM/images/defaultwebcam.png`,
            // img: `/CRM/images/defaultwebcam.png`,
            camera: null,
            deviceId: null,
            devices: [],
            defaultwebcam: `${process.env.BASE_URL}images/defaultwebcam.png`,
            // defaultwebcam: `/Tuguegarao-CRM/images/defaultwebcam.png`,
            // defaultwebcam: `/CRM/images/defaultwebcam.png`,
            // tc_logo: `${process.env.BASE_URL}images/tc.png`,
            // tc_logo: `/Tuguegarao-CRM/images/tc.png`,
            // tc_logo: `/CRM/images/tc.png`,
            output: null,
        }
    },
    methods: {
        ucwords (str) {
            //  discuss at: https://locutus.io/php/ucwords/
            // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
            // improved by: Waldo Malqui Silva (https://waldo.malqui.info)
            // improved by: Robin
            // improved by: Kevin van Zonneveld (https://kvz.io)
            // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
            // bugfixed by: Cetvertacov Alexandr (https://github.com/cetver)
            //    input by: James (https://www.james-bell.co.uk/)
            //   example 1: ucwords('kevin van  zonneveld')
            //   returns 1: 'Kevin Van  Zonneveld'
            //   example 2: ucwords('HELLO WORLD')
            //   returns 2: 'HELLO WORLD'
            //   example 3: ucwords('у мэри был маленький ягненок и она его очень любила')
            //   returns 3: 'У Мэри Был Маленький Ягненок И Она Его Очень Любила'
            //   example 4: ucwords('τάχιστη αλώπηξ βαφής ψημένη γη, δρασκελίζει υπέρ νωθρού κυνός')
            //   returns 4: 'Τάχιστη Αλώπηξ Βαφής Ψημένη Γη, Δρασκελίζει Υπέρ Νωθρού Κυνός'
            return (str + '')
                .replace(/^(.)|\s+(.)/g, function ($1) {
                return $1.toUpperCase()
                })
        },
        ucfirst (str) {
            //  discuss at: https://locutus.io/php/ucfirst/
            // original by: Kevin van Zonneveld (https://kvz.io)
            // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
            // improved by: Brett Zamir (https://brett-zamir.me)
            //   example 1: ucfirst('kevin van zonneveld')
            //   returns 1: 'Kevin van zonneveld'
            str += ''
            const f = str.charAt(0)
                .toUpperCase()
            return f + str.substr(1)
        },
        StartCase(_f) {
            const e = this.ucwords(_.toLower(_f))

            return e
        },
        ForgotPasswordTrigger() {
            this.forgotpassworddialog = true
            this.isforgotpass = true
        },
        // registration
        EmptyRecord() {
            this.citizen = {
                citizen_id: '',
                username: '',
                password: '',
                firstname: '',
                lastname: '',
                middlename: '',
                fullname_format1: '',
                fullname_format2: '',
                gender: 'm',
                birthdate: moment().subtract(10, 'years').toISOString().substr(0, 10),
                mobile: '',
                mobilevalid: false,
                mobileformatted: '',
                email: '',
                address: {
                    permanent: {
                        street: '',
                        brgy: '',
                        city: 'Tuguegarao City',
                        province: 'Cagayan',
                        address1: '',
                        address2: '',
                        country: 'Philippines',
                        zipcode: 3500,
                        istugue: true,
                        latlng: [ 17.611138, 121.7257458 ],
                        zoom: 13
                    },
                    present: {
                        street: '',
                        brgy: '',
                        city: 'Tuguegarao City',
                        province: 'Cagayan',
                        address1: '',
                        address2: '',
                        country: 'Philippines',
                        zipcode: 3500,
                        istugue: false,
                        latlng: [ 17.611138, 121.7257458 ],
                        zoom: 13
                    }
                },
                fathers_name: '',
                mothers_maiden_name: '',
                civil_status: 'S',
                nationality: 'Filipino',
                tin: '',
                accounttype: 'individual',
                // new
                birthplace: '',
                spousename: '',
                occupation: '',
                educational_attainment: '',
                extensionname: '',
                incaseofemergency: {
                    name: '',
                    address: '',
                    contactnumber: '',
                },
                companyname: '',
                businesstype: '',
                date_established: moment().toISOString().substr(0, 10),
                representative: {
                    name: '',
                    email: '',
                    contactnumber: '',
                    mobilevalid: false,
                    mobileformatted: '',
                },
                secdti: [],
                secdtidata: [],
                boardresolutionauthorizingrep: [],
                boardresolutionauthorizingrepdata: [],
                cphoto: undefined,
                cphotodata: '',
                cphotovalidid: undefined,
                cphotovalididdata: '',
                tugueresident: true,
            }

            this.croppedphoto = {
                coordinates: undefined,
                dataurl: undefined,
            }
        },
        AddNewRecord() {
            this.EmptyRecord()
            this.active_tab = 0
            this.citizenform = true
            this.img = `${process.env.BASE_URL}images/defaultwebcam.png`
            this.imgvalidid = `${process.env.BASE_URL}images/defaultwebcam.png`
            this.tcagree = false
            this.tcbottom = false
            // this.img = `/Tuguegarao-CRM-User/images/defaultwebcam.png`

            setTimeout(() => {
                this.$refs.citfirstname.focus()
            }, 500)
        },
        // new crop photo
        CropPhoto({ coordinates, canvas, }) {
            if(parseInt(coordinates.height) > 0 && parseInt(coordinates.width) > 0){
                this.croppedphoto.coordinates = coordinates
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image, that can be used 
                // as src for <img/> to preview result
                this.croppedphoto.dataurl = canvas.toDataURL()
            }
        },
        SelectCroppedPhoto() {
            this.citizen.cphotodata = this.croppedphoto.dataurl

            this.cropform = false
        },
        async FileAttachment(file) {
            this.citizen.cphotodata = ''

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            toBase64(file).then(mfile => {
                this.citizen.cphotodata = mfile

                this.img = mfile

                this.cropform = true
            }).catch(() => {

            })
        },
        // new valid id
        async FileAttachmentValidId(file) {
            this.citizen.cphotovalididdata = ''

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            toBase64(file).then(mfile => {
                this.citizen.cphotovalididdata = mfile

                this.imgvalidid = mfile
            }).catch(() => {

            })
        },
        async FileAttachmentSEC(files) {
            this.citizen.secdtidata = []

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            for await (let file of files) {
                toBase64(file).then(mfile => {
                    this.citizen.secdtidata.push(mfile)
                }).catch(() => {

                })
            }
        },
        async FileAttachmentAuthRep(files) {
            this.citizen.boardresolutionauthorizingrepdata = []

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            for await (let file of files) {
                toBase64(file).then(mfile => {
                    this.citizen.boardresolutionauthorizingrepdata.push(mfile)
                }).catch(() => {

                })
            }
        },
        SaveProcessDisabled() {
            const permanent = this.citizen.address.permanent.istugue ? this.citizen.address.permanent.brgy.toString().length > 0 && this.citizen.address.permanent.street.toString().length > 0 : this.citizen.address.permanent.address1.toString().length > 0 && this.citizen.address.permanent.city.toString().length > 0 && this.citizen.address.permanent.province.toString().length > 0 && this.citizen.address.permanent.country.toString().length > 0

            const present = this.citizen.address.present.istugue ? this.citizen.address.present.brgy.toString().length > 0 && this.citizen.address.present.street.toString().length > 0 : this.citizen.address.present.address1.toString().length > 0 && this.citizen.address.present.city.toString().length > 0 && this.citizen.address.present.province.toString().length > 0 && this.citizen.address.present.country.toString().length > 0

            let spouse = false

            if(this.citizen.civil_status.toString().toUpperCase() == 'M'){
                if(this.citizen.spousename.toString().length > 0){
                    spouse = true
                }
            } else{
                spouse = true
            }

            if(this.citizen.accounttype.toString() == 'individual'){
                return (
                    this.citizen.mobile.toString().length > 0
                    // && this.citizen.fathers_name.toString().length > 0
                    // && this.citizen.mothers_maiden_name.toString().length > 0
                    && permanent
                    && present
                    && this.citizen.firstname.toString().length > 0
                    && this.citizen.middlename.toString().length > 0
                    && this.citizen.lastname.toString().length > 0
                    && this.citizen.birthdate.toString().length > 0
                    && this.citizen.gender.toString().length > 0
                    && this.citizen.birthplace.toString().length > 0
                    // && this.citizen.nationality.toString().length > 0
                    && this.citizen.email.toString().length > 0
                    && spouse
                    && this.tcagree
                ) == false
            } else{
                return (
                    this.citizen.mobile.toString().length > 0
                    && this.citizen.companyname.toString().length > 0
                    && this.citizen.businesstype.toString().length > 0
                    && this.citizen.representative.name.toString().length > 0
                    && this.citizen.representative.email.toString().length > 0
                    && this.citizen.representative.contactnumber.toString().length > 0
                    && this.citizen.email.toString().length > 0
                    && this.citizen.tin.toString().length > 0
                    && permanent
                    && present
                    && this.tcagree
                ) == false
            }
        },
        CloseDialog() {
            this.onStop()
            
            setTimeout(() => {
                this.citizenform = false
            }, 500)
        },
        onRenewCapture() {
            this.img = `${process.env.BASE_URL}images/defaultwebcam.png`
            // this.img = `/Tuguegarao-CRM/images/defaultwebcam.png`

            this.citizen.cphoto = undefined
            this.citizen.cphotodata = undefined

            this.onStart()
        },
        onCapture() {
            this.img = this.$refs.webcam.capture()

            setTimeout(() => {
                this.onStop()
            }, 500)
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            if(this.$refs.webcam){
                this.$refs.webcam.stop()
            }
        },
        onStart() {
            if(this.$refs.webcam){
                this.$refs.webcam.start()
            }
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        },
        PresentAddressChange() {
            this.citizen.address.present.address1 = ''
            this.citizen.address.present.address2 = ''
            this.citizen.address.present.latlng = [ 17.611138, 121.7257458 ]
            this.citizen.address.present.zoom = 13
            this.citizen.address.present.brgy = ''
            this.citizen.address.present.street = ''

            if(this.citizen.address.present.istugue){
                this.citizen.address.present.city = 'Tuguegarao City'
                this.citizen.address.present.province = 'Cagayan'
                this.citizen.address.present.country = 'Philippines'
                this.citizen.address.present.zipcode = 3500
                this.center2 = [ 17.611138, 121.7257458 ]
                this.MapInvalidateSize()
            } else{
                this.citizen.address.present.city = 'Tuguegarao City'
                this.citizen.address.present.province = 'Cagayan'
                this.citizen.address.present.country = 'Philippines'
                this.citizen.address.present.zipcode = 3500
            }
        },
        PermanentAddressChange() {
            this.citizen.address.permanent.address1 = ''
            this.citizen.address.permanent.address2 = ''
            this.citizen.address.permanent.latlng = [ 17.611138, 121.7257458 ]
            this.citizen.address.permanent.zoom = 13
            this.citizen.address.permanent.brgy = ''
            this.citizen.address.permanent.street = ''

            if(this.citizen.address.permanent.istugue){
                this.citizen.address.permanent.city = 'Tuguegarao City'
                this.citizen.address.permanent.province = 'Cagayan'
                this.citizen.address.permanent.country = 'Philippines'
                this.citizen.address.permanent.zipcode = 3500
                this.center = [ 17.611138, 121.7257458 ]
                this.MapInvalidateSize()
            } else{
                this.citizen.address.permanent.city = 'Tuguegarao City'
                this.citizen.address.permanent.province = 'Cagayan'
                this.citizen.address.permanent.country = 'Philippines'
                this.citizen.address.permanent.zipcode = 3500
            }
        },
        PhoneNumberUpdateRep({number, isValid}) {
            this.citizen.representative.mobilevalid = isValid
            this.citizen.representative.mobileformatted = number.e164
        },
        PhoneNumberUpdate({ number, isValid }) {
            this.citizen.mobilevalid = isValid
            this.citizen.mobileformatted = number.e164
        },
        FullnameFormat() {
            let format1 = []
            let format2 = []

            if(this.citizen.firstname.toString().length > 0){
                format1.push(this.citizen.firstname.toString())
            }

            if(this.citizen.middlename.toString().length > 0){
                format1.push(this.citizen.middlename.toString())
            }

            if(this.citizen.lastname.toString().length > 0){
                format1.push(this.citizen.lastname.toString())
            }

            if(this.citizen.extensionname.toString().length > 0){
                format1.push(this.citizen.extensionname.toString())
            }

            if(this.citizen.lastname.toString().length > 0){
                format2.push(this.citizen.lastname.toString())
            }

            if(this.citizen.extensionname.toString().length > 0){
                format2.push(` ${this.citizen.extensionname.toString()}`)
            }

            if(this.citizen.firstname.toString().length > 0){
                if(format2.length == 0){
                    format2.push(this.citizen.firstname.toString())
                } else{
                    format2.push(`, ${this.citizen.firstname.toString()}`)
                }
            }

            if(this.citizen.middlename.toString().length > 0){
                format2.push(` ${this.citizen.middlename.toString()}`)
            }

            this.citizen.fullname_format1 = format1.join(' ')
            this.citizen.fullname_format2 = format2.join('')
        },
        CopyPermanentAddress() {
            // this.citizen.address.present = _.cloneDeep(this.citizen.address.permanent)

            // this.center2 = this.citizen.address.present.latlng
            // get barangay
            this.citizen.address.present.address2 = ''

            if(this.citizen.address.permanent.brgy.toString().length > 0){
                const brgy = this.brgy.filter(x => {
                    return parseInt(x.BarangayCode) == parseInt(this.citizen.address.permanent.brgy)
                })

                if(brgy.length > 0){
                    this.citizen.address.present.address2 = brgy[0].BarangayName.toString()
                }
            }

            this.citizen.address.present.address1 = this.citizen.address.permanent.street
            this.citizen.address.present.city = 'Tuguegarao City'
            this.citizen.address.present.province = 'Cagayan'
            this.citizen.address.present.country = 'Philippines'
            this.citizen.address.present.zipcode = 3500
        },
        SaveProcess() {
            this.FullnameFormat()

            // console.log(this.citizen)

            if(this.citizen.mobilevalid == false){
                return false
            }

            this.overlay = true
            this.citizenform = false

            const citizenD = _.cloneDeep(this.citizen)
            citizenD.imgUrl = this.img.toString()

            if(citizenD.accounttype.toString() == 'individual'){
                citizenD.secdti = []
                citizenD.secdtidata = []
                citizenD.boardresolutionauthorizingrep = []
                citizenD.boardresolutionauthorizingrepdata = []
            }

            citizenD.secdtidata = JSON.stringify(citizenD.secdtidata)
            citizenD.boardresolutionauthorizingrepdata = JSON.stringify(citizenD.boardresolutionauthorizingrepdata)

            citizenD.mobile = citizenD.mobileformatted || citizenD.mobile
            citizenD.representative.contactnumber = citizenD.representative.mobileformatted || citizenD.representative.contactnumber
            delete citizenD.cphoto

            citizenD.imgUrl = this.croppedphoto.dataurl ? this.croppedphoto.dataurl.toString() : ''
            
            delete citizenD.cphotodata

            citizenD.imgUrlValidId = citizenD.cphotovalididdata.toString()

            delete citizenD.cphotovalidid
            delete citizenD.cphotovalididdata

            citizenD.photocoordinates = this.croppedphoto.coordinates
            // citizenD.imgUrl = this.img.toString()

            // console.log(citizenD)

            axios({
                method: 'post',
                url: `${this.domain}/crm_citizen_process`,
                data: citizenD
            })
                .then(response => {
                    this.overlay = false
                    this.showSnackbar = true

                    if(response.data.response){
                        this.snackbarVariant = 'green darken-3'
                        // this.modalMessage = 'Citizen registration was successful, your temporary Username and Password were sent to your Email/Mobile, an activation link was sent to your email or provide your registered phone number upon logging in. In case you did not received an email, kindly check your spam folder.'
                        this.modalMessage = `You are now Registered to Digital Tuguegarao. An activation link was sent to your email, together with your username and password. Note: Please check your SPAM FOLDER, if confirmation email is not in your inbox.`
                    } else{
                        this.citizenform = true

                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message.toString()
                    }
                })
        },
        lookupBrgy() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_lookup_brgy`,
                data: {}
            })
                .then(response => {
                    if(response.data.response){
                        this.brgy = response.data.brgy
                    }
                })
        },
        MapInvalidateSize() {
            setTimeout(() => {
                if(parseInt(this.active_tab) == 1){
                    this.$refs.myMap.mapObject.invalidateSize()
                    this.$refs.myMap2.mapObject.invalidateSize()
                }

                if(parseInt(this.active_tab) == 3){
                    this.onStart()
                }
            }, 100)
        },
        onreadymap() {
            this.map = this.$refs.myMap.mapObject
            this.map2 = this.$refs.myMap2.mapObject
        },
        UpdateLocationPermanent() {
            console.log(this.citizen.address.permanent.latlng)
        },
        ReverseGeocoderPresent() {
            const geocoder = new Nominatim()
            let address = []

            if(this.citizen.address.present.istugue){
                if(this.citizen.address.present.street.toString().length > 0){
                    address.push(this.citizen.address.present.street.toString())
                }

                const barangay = this.brgy.filter(x => {
                    return parseInt(x.BarangayCode) == parseInt(this.citizen.address.present.brgy)
                })

                if(barangay.length > 0){
                    address.push(barangay[0].BarangayName.toString())
                }
            } else{
                address.push(this.citizen.address.present.address1.toString())
                address.push(this.citizen.address.present.address2.toString())
            }

            address.push(this.citizen.address.present.city.toString())
            address.push(this.citizen.address.present.province.toString())
            address.push(this.citizen.address.present.zipcode.toString())
            address.push(this.citizen.address.present.country.toString())

            geocoder.search( { q: address.join(', ') } )
                .then((response) => {
                    if(response.length > 0){
                        this.citizen.address.present.latlng = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                        this.center2 = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                    } else{
                        // this.showSnackbar = true
                        // this.snackbarVariant = 'red darken-3'
                        // this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                        console.log(111111)
                    }
                })
                .catch(() => {
                    // this.showSnackbar = true
                    // this.snackbarVariant = 'red darken-3'
                    // this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                    console.log(22222)
                })
        },
        ReverseGeocoderPermanent() {
            const geocoder = new Nominatim()
            let address = []

            if(this.citizen.address.permanent.istugue){
                if(this.citizen.address.permanent.street.toString().length > 0){
                    address.push(this.citizen.address.permanent.street.toString())
                }

                const barangay = this.brgy.filter(x => {
                    return parseInt(x.BarangayCode) == parseInt(this.citizen.address.permanent.brgy)
                })

                if(barangay.length > 0){
                    address.push(barangay[0].BarangayName.toString())
                }
            } else{
                address.push(this.citizen.address.permanent.address1.toString())
                address.push(this.citizen.address.permanent.address2.toString())
            }

            address.push(this.citizen.address.permanent.city.toString())
            address.push(this.citizen.address.permanent.province.toString())
            address.push(this.citizen.address.permanent.zipcode.toString())
            address.push(this.citizen.address.permanent.country.toString())

            geocoder.search( { q: address.join(', ') } )
                .then((response) => {
                    if(response.length > 0){
                        this.citizen.address.permanent.latlng = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                        this.center = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                    } else{
                        // this.showSnackbar = true
                        // this.snackbarVariant = 'red darken-3'
                        // this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                        console.log(333333)
                    }
                })
                .catch(() => {
                    // this.showSnackbar = true
                    // this.snackbarVariant = 'red darken-3'
                    // this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                    console.log(444444)
                })
        },
        // end
        ValidatePhoneNumber({ number, isValid }) {
            this.validnumber = isValid
            this.mobileformatted = number.e164
        },
        ResetPassword() {
            this.overlay = true
            this.resetpassworddialog = false

            axios({
                method: 'post',
                url: `${this.domain}/crm_reset_password`,
                data: {
                    otpid: this.otpid.toString(),
                    otpcode: this.forgototpcode.toString(),
                    newpassword: this.resetpassword.new.toString(),
                    confirmpassword: this.resetpassword.confirm.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.overlay = false

                        this.showSnackbar = true
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = 'Password reset was successful'

                        this.resetpassword = {
                            new: '',
                            confirm: '',
                        }

                        this.otpid = ''
                        this.forgototpcode = ''
                    } else{
                        this.overlay = false
                        this.resetpassworddialog = true

                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch(() => {
                    this.overlay = false
                    this.resetpassworddialog = true

                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = 'Something went wrong... Try again later...'
                })
        },
        ForgotPasswordProcess() {
            this.overlay = true
            this.forgotpassworddialog = false

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_forgot_password_v2`,
                data: {
                    username: this.forgotpass.username,
                    otpid: this.otpid.toString(),
                    otpcode: this.forgototpcode.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.overlay = false

                        this.showSnackbar = true
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = 'You may now reset your password'

                        this.forgotpass = {
                            father: '',
                            mother: '',
                            username: ''
                        }

                        this.resetpassworddialog = true
                    } else{
                        this.overlay = false
                        this.forgotpassworddialog = true

                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch(() => {
                    this.overlay = false
                    this.forgotpassworddialog = true

                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = 'Something went wrong... Try again later...'
                })
        },
        ActivateAccountV2() {
            this.overlay = true
            this.activationdialog = false

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_activate_account_v2`,
                data: {
                    u: this.recordidtoactivate.toString(),
                    otpcode: this.otpcode.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.showSnackbar = true
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = 'Activation successful... Logging you in...'

                        // this.$session.start()
                        // this.$session.set('crmusersessionsignature', response.data.jwt)
                        // this.$ls.set('isLoggedIn', true)
                        // localStorage.setItem('crm_entryauth',response.data.auth)

                        // console.log(response.data)

                        setTimeout(() => {
                            this.$router.push({
                                name: 'sessionverify',
                                params: {
                                    authid: response.data.authid.toString(),
                                },
                                query: {
                                    redirect: encodeURIComponent(`${this.localdomain}`)
                                },
                            }).catch(()=>{})
                        }, 2000)
                    } else{
                        this.overlay = false
                        this.activationdialog = true
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch((err) => {
                    console.log(err.toString())
                    this.overlay = false
                    this.activationdialog = true

                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = 'Something went wrong... Try again later...'
                })
        },
        ActivateAccount() {
            this.overlay = true
            this.activationdialog = false

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_activate_account`,
                data: {
                    username: this.username,
                    password: this.password,
                    mobile: this.mobileformatted
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.showSnackbar = true
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = 'Activation successful... Logging you in...'

                        // this.$session.start()
                        // this.$session.set('crmusersessionsignature', response.data.jwt)
                        // this.$ls.set('isLoggedIn', true)
                        // localStorage.setItem('crm_entryauth',response.data.auth)

                        // console.log(response.data)

                        setTimeout(() => {
                            this.$router.push({
                                name: 'sessionverify',
                                params: {
                                    authid: response.data.authid.toString(),
                                },
                                query: {
                                    redirect: encodeURIComponent(`${this.localdomain}`)
                                },
                            }).catch(()=>{})
                        }, 2000)
                    } else{
                        this.overlay = false
                        this.activationdialog = true
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch((err) => {
                    console.log(err.toString())
                    this.overlay = false
                    this.activationdialog = true

                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = 'Something went wrong... Try again later...'
                })
        },
        SendOTP(forgotpassword = false) {
            this.otpid = ''

            if(forgotpassword){
                axios({
                    method: 'post',
                    url: `${this.domain}/crm_send_otp_forgot_password`,
                    data: {
                        username: this.forgotpass.username.toString(),
                    }
                })
                    .then(response => {
                        // console.log(response.data)
                        if(response.data.response){
                            this.otpid = response.data.uid.toString()
                        }
                    })
            } else{
                if(this.recordidtoactivate.toString().length > 0){
                    axios({
                        method: 'post',
                        url: `${this.domain}/crm_send_otp`,
                        data: {
                            u: this.recordidtoactivate.toString(),
                        }
                    })
                        .then(response => {
                            if(response.data.response){
                                this.otpid = response.data.uid.toString()
                            }
                        })
                }
            }
        },
        LoginProcess() {
            this.overlay = true
            this.recordidtoactivate = ''
            this.otpcode = ''

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_login`,
                data: {
                    username: this.username,
                    password: this.password
                }
            })
                .then(response => {
                    if(response.data.response){
                        // check if user needs to be activated
                        const { user } = this.$jwt.decode(response.data.jwt, this.jwtsecret)

                        if(parseInt(user.status) == 1){
                            this.overlay = false
                            this.activationdialog = true
                            this.recordidtoactivate = user._id.toString()
                            // this.forgotpass.username = this.username.toString()
                            this.isforgotpass = false

                            this.SendOTP(this.isforgotpass)
                        } else{
                            this.showSnackbar = true
                            this.snackbarVariant = 'green darken-3'
                            this.modalMessage = 'Login successful... Redirecting...'

                            // this.$session.start()
                            // this.$session.set('crmusersessionsignature', response.data.jwt)
                            // this.$ls.set('isLoggedIn', true)

                            // localStorage.setItem('crm_entryauth',response.data.auth)

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'sessionverify',
                                    params: {
                                        authid: response.data.authid.toString(),
                                    },
                                    query: {
                                        redirect: encodeURIComponent(`${this.localdomain}`)
                                    },
                                }).catch(()=>{})
                            }, 2000)
                        }
                    } else{
                        this.overlay = false
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch(() => {
                    this.overlay = false

                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = 'Something went wrong... Try again later...'
                })
        },
        TC() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_tc_fetch`,
                data: {
                    tc: '60f53530b467af5ae7b0ebde'
                }
            })
                .then(response => {
                    if(response.data.response){
                        const tc = this.$jwt.decode(response.data.tc, this.jwtsecret)

                        // console.log(tc)
                        if(tc.tc.tac && tc.tc.tac.toString().length > 0){
                            this.tchtml = tc.tc.tac.toString()
                            this.tctitle = tc.tc.name.toString()
                        }
                    }
                })
        },
        PrivacyPolicy() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_tc_fetch`,
                data: {
                    tc: '6110ee267bbc731bed9856e1'
                }
            })
                .then(response => {
                    if(response.data.response){
                        const tc = this.$jwt.decode(response.data.tc, this.jwtsecret)

                        if(tc.tc.tac && tc.tc.tac.toString().length > 0){
                            this.privacyhtml = tc.tc.tac.toString()
                            this.privacytitle = tc.tc.name.toString()
                        }
                    }
                })
        },
        IAgree() {
            this.tcagree = true
            this.tcdialog = false
        },
        TCScroll(el) {
            if((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
                this.tcbottom = true
            }
        },
        ReadTC() {
            this.tcdialog = true

            setTimeout(() => {
                document.querySelector('#tccontainer').scrollTo(0, 0)
            }, 500)
        },
    },
    mounted() {
        this.lookupBrgy()

        this.CRM_Interval = setInterval(() => {
            if(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature')){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'dashboard'
                }).catch(()=>{})
            }
        }, 500)

        localStorage.removeItem('app-xstate')

        if(this.$route.query.signup && parseInt(this.$route.query.signup) == 1){
            this.AddNewRecord()
        }

        this.TC()
        this.PrivacyPolicy()
    },
    beforeCreate: function () {
        if (this.$session.exists()) {
            if(this.$session.get('crmusersessionsignature')){
                this.$router.push({
                    name: 'dashboard'
                }).catch(()=>{})
            }
        } else{
            this.$emit('updatesession', false)
        }
    },
}
</script>

<style>
.country-selector__list{
    z-index: 3000;
}
</style>